/**
 * Call concurrency limits and presets shared by the settings page and the
 * onboarding call-concurrency step. Values above the org's
 * maxAllowedConcurrency are managed by support. 0 is no longer a customer
 * option — treat a stored 0 as the org's maxAllowedConcurrency in the UI.
 */
export const MIN_CUSTOMER_CONCURRENCY = 1;

/**
 * Fallback default for maxAllowedConcurrency when the restriction field is
 * missing and the account is not Enterprise (Enterprise defaults to 2000 in
 * GetRestrictions).
 */
export const MAX_CUSTOMER_CONCURRENCY = 30;

/** Preset choices surfaced as quick options in the UI. */
export const CONCURRENCY_PRESETS = [1, 3, 5] as const;

/** Presets that are at or below the org's allowed maximum. */
export function getAllowedPresets(max: number): number[] {
  return CONCURRENCY_PRESETS.filter((preset) => preset <= max);
}
